import { useIntl } from 'react-intl';
import IconButton from '@alltrails/denali/components/IconButton';
import Heart from '@alltrails/denali/icons/Heart';
import HeartFilled from '@alltrails/denali/icons/HeartFilled';
import styles from './TopResults.module.scss';

type Props = {
  isFavorite: boolean;
  onClick: () => void;
};

const HeartButtonWrapper = ({ isFavorite, onClick }: Props) => {
  const intl = useIntl();

  return (
    <IconButton
      className={styles.trailCardSnippetHeart}
      icon={isFavorite ? { Component: HeartFilled } : { Component: Heart }}
      onClick={onClick}
      title={intl.formatMessage({ defaultMessage: 'Add to list' })}
      size="sm"
    />
  );
};

export default HeartButtonWrapper;
